import React from 'react';
import { ArrowRight, Check, FileText, Workflow, BarChart3, MessageSquare, Brain, Shield } from 'lucide-react';

const VisionSection = ({ onNavigate }) => {
    const handleGetStarted = () => {
        onNavigate('/assessment');
    };

    return (
        <section className="py-16 md:py-28 px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
                <div className="mx-auto max-w-3xl text-center mb-16">
                    <div className="inline-block px-3 py-1 bg-blue-900/30 rounded-full text-blue-400 text-sm font-medium mb-4 border border-blue-700/30">
                        Your Future
                    </div>
                    <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                        Our <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Vision</span>
                    </h1>
                    <p className="text-xl text-slate-300 leading-relaxed mb-10">
                        We imagine a world where every company can use all of their data to its fullest potential,
                        like how oil changed the world. Where insights are easy to find, decisions are smarter,
                        and new ideas come from better understanding.
                    </p>

                    {/* DIO Logo Visualization - simplified approach */}
                    <div className="relative h-32 mb-10">
                        {/* Extended pipeline with full width */}
                        <div className="absolute inset-x-0 h-12 top-1/2 transform -translate-y-1/2 bg-slate-800 rounded-full border border-blue-500/30">
                            {/* Pipeline segments */}
                            {[...Array(12)].map((_, i) => (
                                <div
                                    key={i}
                                    className="absolute h-full w-8"
                                    style={{ left: `${i * 8.33}%`, borderRight: '1px solid rgba(59, 130, 246, 0.3)' }}
                                ></div>
                            ))}
                        </div>

                        {/* Using flex to guarantee even spacing */}
                        <div className="absolute inset-x-0 top-1/2 transform -translate-y-1/2 flex justify-between px-5">
                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/20 border-4 border-slate-800">
                                <FileText className="w-10 h-10 text-white" />
                            </div>

                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-green-500 to-green-600 flex items-center justify-center shadow-lg shadow-green-500/20 border-4 border-slate-800">
                                <Workflow className="w-10 h-10 text-white" />
                            </div>

                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/20 border-4 border-slate-800">
                                <BarChart3 className="w-10 h-10 text-white" />
                            </div>

                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-purple-500 to-purple-600 flex items-center justify-center shadow-lg shadow-purple-500/20 border-4 border-slate-800">
                                <MessageSquare className="w-10 h-10 text-white" />
                            </div>

                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-cyan-500 to-cyan-600 flex items-center justify-center shadow-lg shadow-cyan-500/20 border-4 border-slate-800">
                                <Brain className="w-10 h-10 text-white" />
                            </div>

                            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center shadow-lg shadow-red-500/20 border-4 border-slate-800">
                                <Shield className="w-10 h-10 text-white" />
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                        <div className="flex items-start">
                            <div className="bg-blue-500/20 p-1 rounded-full mr-3 mt-1">
                                <Check className="w-4 h-4 text-blue-400" />
                            </div>
                            <p className="text-slate-300 text-sm">Increased data-driven decision making</p>
                        </div>
                        <div className="flex items-start">
                            <div className="bg-blue-500/20 p-1 rounded-full mr-3 mt-1">
                                <Check className="w-4 h-4 text-blue-400" />
                            </div>
                            <p className="text-slate-300 text-sm">Enhanced operational efficiency</p>
                        </div>
                        <div className="flex items-start">
                            <div className="bg-blue-500/20 p-1 rounded-full mr-3 mt-1">
                                <Check className="w-4 h-4 text-blue-400" />
                            </div>
                            <p className="text-slate-300 text-sm">AI-powered growth strategies</p>
                        </div>
                    </div>
                    <button
                        onClick={handleGetStarted}
                        className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 rounded-lg 
                        text-base font-semibold transition-all duration-300 shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 flex items-center mx-auto">
                        Get Started Today
                        <ArrowRight className="w-4 h-4 ml-2" />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default VisionSection;